exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer-component{margin-bottom:0;bottom:0;left:0;background-color:#fff;border-top:1px solid #f5f5f5;position:fixed;width:100%;height:50px;text-align:center}@media only screen and (min-width:600px){.footer-component{width:598px!important;left:calc((100vw - 598px)/2)}}.footer-component a{color:#9b9b9b;height:100%}.footer-component a.active{color:#333}.footer-component .fa{margin-top:9px;font-size:18px;line-height:1}.footer-component .fz10{font-size:10px;line-height:1;margin-top:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/Footer.scss
// module id = 639
// module chunks = 0